<template>
	<div class="videoBox" id="homeid" v-show="monArr.length > 0">
		<!-- 宫格切换 -->
		<div class="gongge">
			<div class="metre-num">
				<!-- <el-col
          :span="8"
          v-for="(item,index) in geArr"
          :key="index"
        >
          <div
            class="elC"
            @click="imgGeClick(item,index)"
          >
            <img
              :src="activeIndex === index ?item.imgurl2 :item.imgurl"
              alt=""
            >
          </div>
        </el-col> -->
			</div>
			<div class="magnify">
				<div class="magnify-btn" @click="fullScreenClick">
					<img :src="screenImg" alt="" />
				</div>
			</div>
		</div>
		<!-- 视频内容 -->
		<div class="shiping">
			<div class="parent" :style="parentGongge">
				<div class="parent-box" v-for="(item, index) in monArr" :key="index">
					<video
                        muted
						class="videoa video-js "
						:playUrl="item.urlM3u8"
						:ref="`my-player${index}`"
            			autoplay
					></video>
				</div>
			</div>
		</div>
		<div
			class="video-arr video-arrL"
			@click="videoArrLClick"
			v-show="showVideoArrLClick"
		></div>
		<div
			class="video-arr video-arrR"
			@click="videoArrRClick"
			v-show="showVideoArrRClick"
		></div>
	</div>
</template>

<script>
import { dataInterface } from '@/api/dataInterfaceApi'

export default {
	data() {
		return {
			showVideoArrLClick: false,
			showVideoArrRClick: false,
			monArr: [],
			parentGongge:
				'grid-template-columns: grid-template-columns: repeat(2, 49%);grid-template-rows: repeat(2, 49%);',
			screenImg: require('@/assets/images/index/fullscreen.png'),
			a: 0,
			listQuery: {
				currentPage: 1,
				pageSize: 4,
				sort: 'desc',
			},
			totalPages: 0,
			number: 1,
            videoObj: {},
			stationId: '2d69ab8b69ec4edfad613400a3261b0b',
		}
	},
	components: {},
	// watch: {
	//   monArr:{
	//     handler(newValue,oldValue){
	//       console.log(newValue,'this.monArr')
	//       if(newValue.length&&newValue.length>0){
	//       }
	//     },
	//     immediate: true,
	//     deep: true
	//   }
	// },
	mounted() {
		this.getData(this.$route.query && this.$route.query.stationId)
	},
	methods: {
		getData(stationId) {
			if (stationId) {
				this.serchStreaming(stationId)
			} else {
				this.serchStreaming('14741a1d1ec94ae8a32e503d5cc5c3a6')
			}
		},
		// 查询返回的直播流
		 serchStreaming(stationId) {
			var params = {
				id: this.stationId,
				pageSize: this.listQuery.pageSize,
				currentPage: this.listQuery.currentPage,
			}
			dataInterface
				.gclVideoLiveInfo(params)
				.then(async (res) => {
					if (!res) return
					// console.log('查询到的直播流数据', res)
					// this.total = res.data.total
					this.monArr = res.records
					for (let i = 0; i < 	this.monArr.length; i++) {
					var url = await dataInterface.getcode({deviceCode:this.monArr[i].urlM3u8})
					console.log(url,'请求返回的url');
					this.monArr[i].urlM3u8=url.url
					}
					// this.getCode(this.monArr)
					console.log('都走完2');
					// this.monArr.pop()
					// console.log(res.records.length)
					if (this.listQuery.currentPage < res.pages) {
						this.showVideoArrRClick = true
					} else {
						this.showVideoArrRClick = false
					}
					this.totalPages = res.total
					// if (this.activeIndex == 2) {
					// if (this.monArr.length != 0 && this.monArr.length < 9) {
					// 	let num = Number(9) - Number(this.monArr.length)
					// 	let str = { url: '' }
					// 	for (var t = 0; t < num; t++) {
					// 		this.monArr.push(str)
					// 	}
					// }
					this.videoObj = {}
					this.$nextTick(() => {
						this.monArr.forEach((item, index) => {
							const playerDom = this.$refs[`my-player${index}`][0]
							Object.assign(this.videoObj, {
								[`video${index}`]: videojs(
									playerDom,
									{
										// autoplay: true, // 设置自动播放
										controls: true, // 显示播放的控件
										preload: 'metadata',
										aspectRatio: '16:9',
										fluid: true,
										sources: [
											// 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
											{
												src: playerDom.attributes.playUrl.nodeValue,
												type: 'application/x-mpegURL', // 告诉videojs,这是一个hls流
											},
										],
									},
								),
							})
						})
					})
					// }

					// if (this.activeIndex == 1) {
					//   if (this.monArr.length < 4) {
					//     let num = Number(4) - Number(this.monArr.length)
					//     let str = { url: '' }
					//     for (var t = 0; t < num; t++) {
					//       this.monArr.push(str)
					//     }
					//   }
					// }
					// if (this.dataId.id != "0") {
					//   clearTimeout(this.timer)
					// }
					// console.log('处理之后的数据', this.monArr)
				})
				.catch((err) => {
					console.log(err)
				})
		},

		fullScreenClick() {
			this.a++
			this.a % 2 == 1 ? this.enterfullscreen() : this.exitfullscreen()
			if (this.a % 2 == 1) {
				this.screenImg = require('@/assets/images/index/fullscreen-exit.png')
				this.parentGongge =
					'grid-template-columns: repeat(2, 49%);grid-template-rows: repeat(2, 49%);'
			} else {
				this.screenImg = require('@/assets/images/index/fullscreen.png')
				this.parentGongge =
					'grid-template-columns: repeat(2, 49%);grid-template-rows: repeat(2, 49%);'
			}
		},
		//控制全屏
		enterfullscreen() {
			//进入全屏
			var docElm = document.getElementById('homeid') // 指定容器id
			//W3C
			if (docElm.requestFullscreen) {
				docElm.requestFullscreen()
			}
			//FireFox
			else if (docElm.mozRequestFullScreen) {
				docElm.mozRequestFullScreen()
			}
			//Chrome等
			else if (docElm.webkitRequestFullScreen) {
				docElm.webkitRequestFullScreen()
			}
			//IE11
			else if (docElm.msRequestFullscreen) {
				docElm.msRequestFullscreen()
			}
		},
		//退出全屏
		exitfullscreen() {
			if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen()
			} else if (document.webkitCancelFullScreen) {
				document.webkitCancelFullScreen()
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen()
			}
		},
		//点击左边
		videoArrLClick() {
			// this.showVideoArrRClick = true;
			if (this.number != 1) {
				this.number--
				this.listQuery.currentPage = this.number
				this.showVideoArrLClick = true
				this.serchStreaming(this.stationId)
				if (this.listQuery.currentPage == 1) {
					this.showVideoArrLClick = false
				}
			}
		},
		//点击右边
		videoArrRClick() {
			this.showVideoArrLClick = true
			if (this.number < this.totalPages) {
				this.number++
				this.listQuery.currentPage = this.number
				// this.showVideoArrRClick = true;
				this.serchStreaming(this.stationId)
				if (this.listQuery.currentPage == this.totalPages) {
					this.showVideoArrRClick = false
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.videoBox {
	height: 100%;
	position: relative;
	flex: 1;
	// background: #ffffff;
	// padding: 5px;
	display: flex;
	flex-direction: column; /*垂直方向排列*/
	.gongge {
		// height: 50px;
		.metre-num {
			width: 194px;
			height: 50px;
			// background: #eff1f4;
			border-radius: 7px;
			float: left;
			.el-col {
				.elC {
					width: 37px;
					height: 20px;
					margin: 15px auto;
					cursor: pointer;
					img {
						width: 37px;
						height: 20px;
					}
				}
			}
		}
		.magnify {
			width: 24px;
			height: 50px;
			float: right;
			.magnify-btn {
				width: 24px;
				height: 24px;
				margin: 13px auto;
				cursor: pointer;
				img {
					width: 24px;
					height: 24px;
				}
			}
		}
	}
	.shiping {
		flex: 1;
		height: calc(100% - 100px);
		margin-top: 15px;
		.parent {
			display: grid;
			width: 100%;
			height: 100%;
			justify-content: space-evenly;
			align-content: space-evenly;
			// 4宫格
			grid-template-columns: repeat(2, 49%);
			grid-template-rows: repeat(2, 49%);
			// 9宫格
			// grid-template-columns: repeat(3, 33%);
			// grid-template-rows: repeat(3, 33%);
			// 1宫格
			// grid-template-columns: repeat(1, 100%);
			// grid-template-rows: repeat(1, 100%);
			// grid-template-columns: 410px 410px 410px;
			// grid-template-rows: 232px 232px;
			// justify-content: space-between;
			.parent-box {
				width: 100%;
				// background: pink;
				background-image: url('~@/assets/images/index/available.png');
				background-repeat: no-repeat;
				background-size: 100% 100%;
				.videoa {
					width: 100%;
					height: 100%;
					object-fit: fill;
				}
			}
		}
	}
	.fenye {
		height: 50px;
	}
}
.video-arr {
	position: absolute;
	width: 24px;
	height: 45px;
	background: url('~@/assets/images/index/arrow_left.png');
	background-size: 100% 100%;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
}
.video-arrL {
	left: 0px;
}
.video-arrR {
	background: url('~@/assets/images/index/arrow_right.png');
	background-size: 100% 100%;
	right: 0px;
}
</style>
